import IconWeb from "@mui/icons-material/Language";
import IconLocation from "@mui/icons-material/LocationOn";
import MailIcon from "@mui/icons-material/Mail";
import IconPhone from "@mui/icons-material/Phone";
import IconPerson from "@mui/icons-material/Person";
import { translate } from "../../app/utils";
import "./footer.css";

const Footer = () => {
  const startYear = 2025;
  const currentYear = new Date().getFullYear();
  const displayYear =
    currentYear > startYear ? `${startYear} - ${currentYear}` : `${startYear}`;

  return (
    <div className="footer">
      <div className="info">
        {/* contacts */}
        <div className="container-33 p-20">
          <h3>{translate("contacts")}</h3>
          <div className="contact-info">
            <div className="contact-card">
              <IconLocation style={{ fontSize: "20px", marginRight: "5px" }} />
              <b>{translate("ourOffice")}:</b>
              <p className="al-links">{translate("bankAddress")}</p>
            </div>

            <div className="contact-card">
              <IconPhone style={{ fontSize: "20px", marginRight: "5px" }} />
              <b>{translate("phone")}:</b>
              <a className="al-links" href="tel:+255262963182-7">
                +255(0) 262963182-7
              </a>
              <a className="al-links" href="tel:+255262232541">
                +255(0) 262232541
              </a>
            </div>

            <div className="contact-card">
              <MailIcon style={{ fontSize: "20px", marginRight: "5px" }} />
              <b>{translate("emailUs")}:</b>
              <a className="al-links" href="mailto:info@bot.go.tz">
                info@bot.go.tz
              </a>
            </div>

            <div className="contact-card">
              <IconPerson style={{ fontSize: "20px", marginRight: "5px" }} />
              <b>{translate("visitUs")}:</b>
              <a className="al-links" href="#!">
                {translate("visitingHours")}
              </a>
            </div>
          </div>
        </div>

        {/* important links */}
        <div className="container-33 p-20">
          <h3>{translate("importantLinks")}</h3>
          <a href="https://mof.go.tz" target="_blank" rel="noreferrer">
            <div className="flex-row align-items-center">
              <IconWeb
                style={{ fontSize: "20px", marginRight: "5px", color: "white" }}
              />
              <div className="al-links">{translate("ministryOfFinance")}</div>
            </div>
          </a>
          <a href="https://nbs.go.tz" target="_blank" rel="noreferrer">
            <div className="mt-5 flex-row align-items-center">
              <IconWeb
                style={{ fontSize: "20px", marginRight: "5px", color: "white" }}
              />
              <div className="al-links">
                {translate("nationalBureauOfStatistics")}
              </div>
            </div>
          </a>
          <a href="https://dib.go.tz" target="_blank" rel="noreferrer">
            <div className="mt-5 flex-row align-items-center">
              <IconWeb
                style={{ fontSize: "20px", marginRight: "5px", color: "white" }}
              />
              <div className="al-links">
                {translate("depositorsInsuranceBoard")}
              </div>
            </div>
          </a>
          <a href="https://www.bot.go.tz/" target="_blank" rel="noreferrer">
            <div className="mt-5 flex-row align-items-center">
              <IconWeb
                style={{ fontSize: "20px", marginRight: "5px", color: "white" }}
              />
              <div className="al-links">{translate("botMainSite")}</div>
            </div>
          </a>
          <a
            href="https://training.bot.go.tz/"
            target="_blank"
            rel="noreferrer"
          >
            <div className="mt-5 flex-row align-items-center">
              <IconWeb
                style={{ fontSize: "20px", marginRight: "5px", color: "white" }}
              />
              <div className="al-links">{translate("botAcademySite")}</div>
            </div>
          </a>
        </div>

        {/* map */}
        <div className="container-33 p-20">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3966.5783572356545!2d35.75255527974385!3d-6.187138244612547!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x184de54b7c010887%3A0x35e5b125b0f721ec!2sBank%20Of%20Tanzania!5e0!3m2!1sen!2stz!4v1734935900370!5m2!1sen!2stz"
            width="100%"
            height="350px"
            loading="lazy"
            title={translate("bankOfTanzaniaLibrary")}
            style={{
              borderRadius: "20px",
              border: "unset",
              boxShadow: "2px 5px 15px 3px #babecc",
            }}
          ></iframe>
        </div>
      </div>
      <div className="copyright">
        &copy; {translate("bankOfTanzania")} {displayYear}
      </div>
    </div>
  );
};

export default Footer;
